import { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { CloseIcon, SearchIcon } from "./SvgIcons"
import { setModalOpenFalse, setModalOpenTrue } from "./Modal"
import { Room } from "../../../Types/Room"

function RoomPickerModal(props: {
    isOpen: boolean
    title: string
    searchPlaceholder: string
    emptyStateText: string
    rooms: Room[]
    selectedRoomId?: number | null
    onSelect: (room: Room) => void
    onClose: () => void
}) {
    const [filter, setFilter] = useState("")

    useEffect(() => {
        if (!props.isOpen) {
            return
        }

        setModalOpenTrue()

        return () => {
            setModalOpenFalse()
        }
    }, [props.isOpen])

    useEffect(() => {
        if (props.isOpen) {
            setFilter("")
        }
    }, [props.isOpen])

    if (!props.isOpen) {
        return null
    }

    const filteredRooms = props.rooms.filter(
        room => room.is_active && room.name.toLowerCase().includes(filter.toLowerCase())
    )

    return ReactDOM.createPortal(
        <>
            <div className="modal__overlay" onClick={props.onClose}></div>
            <div className="modal__card">
                <div className="room-picker-modal">
                    <div className="room-picker-modal__header">
                        <div className="room-picker-modal__title">{props.title}</div>
                        <div className="room-picker-modal__close-icon" onClick={props.onClose}>
                            <CloseIcon />
                        </div>
                    </div>

                    <div className="room-picker-modal__search">
                        <SearchIcon color="grey" />
                        <input
                            className="room-picker-modal__search-input"
                            placeholder={props.searchPlaceholder}
                            value={filter}
                            onChange={event => setFilter(event.target.value)}
                            autoComplete="off"
                            autoFocus
                        />
                    </div>

                    <div className="room-picker-modal__list">
                        {filteredRooms.length === 0 ? (
                            <p className="room-picker-modal__empty">{props.emptyStateText}</p>
                        ) : (
                            filteredRooms.map(room => (
                                <div
                                    key={room.id}
                                    className={`room-picker-modal__item ${
                                        props.selectedRoomId === room.id ? "room-picker-modal__item--selected" : ""
                                    }`}
                                    onClick={() => props.onSelect(room)}
                                >
                                    {room.name}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>,
        document.body
    )
}

export default RoomPickerModal
